import { loadStripe } from '@stripe/stripe-js';
import React from 'react';
import { withTranslation } from 'react-i18next';
import Select from 'react-select';

class CardDetails extends React.Component {
    constructor() {
        super();
        this.handleMoodeChange = this.handleMoodeChange.bind(this);

        const isDark = JSON.parse(localStorage.getItem('dark-mode'));
        this.state = {
            card: {
                complete: false,
            },
            isDark: !!isDark,
        };
    }

    componentDidMount() {
        document.addEventListener('changeMoodEvent', this.handleMoodeChange);
    }

    componentWillUnmount() {
        document.removeEventListener('changeMoodEvent', this.handleMoodeChange);
    }

    handleMoodeChange() {
        const isDark = JSON.parse(localStorage.getItem('dark-mode'));
        this.setState({ isDark });
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.addNewCard !== this.props.addNewCard && this.props.addNewCard) {
            this.stripe = await loadStripe(window._config.stripe_public_key);
            this.elements = this.stripe.elements();
            this.card = this.elements.create('card');
            this.card.mount('#card');
            this.props.updateCard(this.card, this.stripe);

            this.card.on('change', (v) => {
                this.props.onEmptyCardError();
                this.setState({
                    card: v,
                });
            });
        }
    }

    render() {
        const { t } = this.props;

        const optionList = this.props.paymentMethods?.map((item) => ({
            value: item.token,
            label: (
                <span
                    className="change-plan-crad"
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                    <span>
                        **** **** **** {item.last_4}{' '}
                        {this.props.default_payment_method === item.token && (
                            <span className="default-selected">{t('change_plan.default')}</span>
                        )}
                    </span>
                    {item.expired && (
                        <div className="d-flex align-items-start">
                            <span className="default-selected expired" title="Expired">
                                {t('change_plan.expired')}
                            </span>
                        </div>
                    )}
                </span>
            ),
        }));
        return (
            <div className="col-xxl-5">
                <div className="card-body change-plan-payment-methods">
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            fontWeight: '600',
                            margin: '17px 0',
                        }}
                    >
                        {t('change_plan.payment_method_header')}
                    </div>
                    <Select
                        options={optionList}
                        defaultValue={optionList.find(
                            (x) => x.value === this.props.default_payment_method,
                        )}
                        styles={{
                            container: (baseStyles) => ({
                                ...baseStyles,
                                width: '100%',
                            }),
                            control: (baseStyles) => ({
                                ...baseStyles,
                                boxShadow: 'none',
                                padding: '1px 3px',
                                fontSize: '13px',
                                backgroundColor: this.state.isDark ? '#2a3142' : 'white',
                                minWidth: '295px',
                                zIndex: 10,
                            }),
                            menuPortal: (provided) => ({
                                ...provided,
                                backgroundColor: this.state.isDark ? '#2a3142' : 'white',
                                zIndex: 999999999,
                            }),
                            menu: (provided) => ({
                                ...provided,
                                ckgroundColor: this.state.isDark ? '#2a3142' : 'white',
                                color: this.state.isDark ? 'white' : 'black',
                                zIndex: 999999999,
                            }),
                            option: (base, state) => ({
                                ...base,
                                color: state.isSelected
                                    ? 'white'
                                    : this.state.isDark
                                    ? 'white'
                                    : 'black',
                                backgroundColor: state.isSelected
                                    ? '#33b1a5'
                                    : this.state.isDark
                                    ? '#2a3142'
                                    : 'white',
                                '&:hover': {
                                    backgroundColor: this.state.isDark ? '#5c6375' : '#d0d5dd',
                                    color: 'white',
                                },
                            }),
                        }}
                        theme={(theme) => ({
                            ...theme,
                            height: '45px',
                            borderRadius: '7px',
                            borderColor: this.state.isDark ? '#1b1c28 ' : '#d9d9d9',
                            transition: 'all 0.2s',
                            backgroundColor: this.state.isDark ? '#2a3142 ' : 'white',
                            zIndex: 10,
                            colors: {
                                ...theme.colors,
                                primary: this.state.isDark ? 'white ' : '#888adb',
                            },
                        })}
                        onChange={this.props.onSelectPaymentMethode}
                        placeholder={t('change_plan.select_card')}
                        isSearchable={false}
                        isDisabled={this.props.addNewCard}
                    />
                    {this.props.errors['selected-card'] && (
                        <div className="error-message">{this.props.errors['selected-card']}</div>
                    )}
                </div>
                <div className="card-body">
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            fontWeight: '600',
                            margin: '17px 0',
                        }}
                    >
                        {t('change_plan.add_new_card')}
                    </div>
                    <span
                        className={`switch-button ${
                            this.props.addNewCard ? 'active' : 'not-active'
                        }`}
                        onClick={this.props.handlePaymentMethod}
                    >
                        <span className="switch-circle" />
                    </span>
                </div>
                {this.props.addNewCard && (
                    <>
                        <div className="card-header" style={{ borderRadius: '10px' }}>
                            <div className="card-title text-dark fw-bold">
                                {t('change_plan.add_card_header')}
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="text-field mb-3">
                                <label htmlFor="first_name" className="form-label">
                                    {t('change_plan.billing_information')}
                                </label>
                                <div id="card" />
                                {this.props.cardError && (
                                    <div className="error-message">{this.props.cardError}</div>
                                )}
                            </div>
                            <div className="text-field mb-3">
                                <label htmlFor="full_name" className="form-label">
                                    {t('change_plan.card_holder_name')}
                                </label>
                                <input
                                    name="full_name"
                                    id="full_name"
                                    className="form-control"
                                    placeholder="John Snow"
                                    value={this.props.cardInfo.full_name}
                                    onChange={(e) =>
                                        this.props.updateCardInfo('full_name', e.target.value)
                                    }
                                    onFocus={this.props.onFocus}
                                />
                                {this.props.errors['full_name'] && (
                                    <div className="error-message">
                                        {this.props.errors['full_name']}
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                )}
            </div>
        );
    }
}

export default withTranslation()(CardDetails);
